import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface ContractPermissionGuardProps {
  children: React.ReactNode;
}

/**
 * Guards contract routes — only allows access to staff users or users in the CJA group.
 * Redirects to /unauthorized if the user doesn't have permission.
 */
const ContractPermissionGuard: React.FC<ContractPermissionGuardProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const { userData } = useSelector((state: any) => state.entities.user);

  const hasAccess = React.useMemo(() => {
    if (!userData) return false;
    if (userData.is_staff) return true;

    const permissions: string[] = userData.user_permissions || [];
    // User has access if they have any contract-related permission
    return permissions.some((p: string) => p.startsWith("contracts."));
  }, [userData]);

  useEffect(() => {
    if (userData && !hasAccess) {
      navigate("/unauthorized");
    }
  }, [userData, hasAccess, navigate]);

  if (!userData || !hasAccess) return null;

  return <>{children}</>;
};

export default ContractPermissionGuard;
